<template>
  <ValidationObserver ref="validator" slim v-if="eanResult">
    <div class="lib__field" data-cy="identification-confirmation-component" v-if="eanResult.error === 'noError'">
      <h3>{{ $t('identification.smartMeter.message') }}</h3>

      <ul class="lib__infobox-list">
        <IdentificationDetails :eanCode='eanCode' :eanResult='eanResult' />
        <InfoBox v-if="eanResult.appointmentSlot && eanResult.appointmentSlot.orderingDate" item level="default">
          <template v-slot:icon>
            <span>
              <i class="fas fa-info-circle"></i>
            </span>
          </template>
          <template>
            <h3 class="lib__text-uppercase">{{ $t('identification.smartMeter.planning') }}</h3>
            <i18n path="identification.smartMeter.orderingDate" tag="p">
              <template v-slot:quarter>
                <strong>{{ $t('identification.smartMeter.quarter.' + eanResult.appointmentSlot.orderingDate.quarter)
                }}</strong>
              </template>
              <template v-slot:quarterLabel>
                <strong>{{ $t('identification.smartMeter.quarterLabel') }}</strong>
              </template>
              <template v-slot:year>
                <strong>{{ eanResult.appointmentSlot.orderingDate.year }}</strong>
              </template>
            </i18n>
          </template>
        </InfoBox>
      </ul>

      <div class="lib__field__note">
        <div>
          <b v-html="$t('identification.smartMeter.wrongAddressMessage')"></b>
          <button class="lib__chat_trigger lib__btn lib__btn--primary lib__btn--small" @click="openChat"><i
              class="fas fa-comments"></i></button>
        </div>
      </div>

    </div>
    <div v-else-if="eanResult.error === 'acdcAppointmentAlreadyScheduledWithRealisationDate'">
      <h3>{{ $t('identification.smartMeter.message') }}</h3>

      <ul class="lib__infobox-list">
        <IdentificationDetails :eanCode='eanCode' :eanResult='eanResult' />
        <InfoBox item level="default">
          <template v-slot:icon>
            <span>
              <i class="fas fa-info-circle"></i>
            </span>
          </template>
          <template>
            <h3 class="lib__text-uppercase">{{ $t('identification.smartMeter.planning') }}</h3>
            <i18n path="identification.smartMeter.realisationDate" tag="p">
              <template v-slot:date>
                <strong>{{ realisationDate }}</strong>
              </template>
              <template v-slot:contractorName>
                <strong>{{ eanResult.contractor.name }}</strong>
              </template>
              <template v-slot:clickHere>
                <a class="lib__no-margin lib__link__mobile--underline" :href="eanResult.contractor.agendaUrl"
                  target="_blank">{{
                    $t('identification.smartMeter.clickHere') }}</a>
              </template>
            </i18n>
          </template>
        </InfoBox>
      </ul>

      <div class="lib__field__note">
        <div>
          <b v-html="$t('identification.smartMeter.wrongAddressMessage')"></b>
          <button class="lib__chat_trigger lib__btn lib__btn--primary lib__btn--small" @click="openChat"><i
              class="fas fa-comments"></i></button>
        </div>
      </div>

    </div>
    <div class="lib__field" data-cy="identification-confirmation-component" v-else>
      <Feedback level="danger" outline simple icon>
        <p v-html="$t(`ean.smartMeter.errors.${eanResult.error}`)"></p>
      </Feedback>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import CollapseInfo from '@/components/display/CollapseInfo.vue'
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { CheckEanSmartMeterResult, EanConnectionContractResult } from '@/models'
import IdentificationDetails from '@/components/inputs/SmartMeterConnection/IdentificationDetails.vue'
import { chatService } from '@/services'
import { dateService } from '@ores/vue-library'

@Component({
  name: 'identification-confirmation',
  components: {
    CollapseInfo,
    IdentificationDetails
  }
})
export default class IdentificationConfirmation extends Vue {
  //#region [Props]
  @Prop({ type: String, required: true }) public readonly eanCode!: string
  @Prop({ type: Object, required: true }) public readonly eanResult!: CheckEanSmartMeterResult
  @Prop({ type: Object, required: false }) public readonly connectionContract!: EanConnectionContractResult
  //#endregion

  //#region [Computed]
  private get realisationDate() {
    return this.eanResult.appointmentSlot?.installationPoint?.realisationDate ?
      dateService.displayDateText(this.eanResult.appointmentSlot.installationPoint.realisationDate) : 'test'
  }

  //#endregion

  //#region [Method]
  private openChat() {
    chatService.openChat()
  }
  //#endregion
}
</script>
